const ReactDOM = require("react-dom")
require("./dist").observerBatching(ReactDOM.unstable_batchedUpdates)



//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/batchingForReactDom.js
// module id = 745
// module chunks = 1